export default __webpack_public_path__ + "static/media/109-focus-deltawaves.dd729c4f.jpeg";